import Autocomplete from './Autocomplete';
export default Autocomplete;



// WEBPACK FOOTER //
// ./src/js/Autocompletes/index.js